import { createContext, useContext } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { DND_TYPES } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColumnDndContext = /*#__PURE__*/createContext({
  isDraggingOver: false,
  cardRef: undefined,
  cardDroppableProps: {},
  cardPlaceholder: undefined,
  draggingFromThisWith: undefined
});
export const ColumnDndProvider = ({
  columnData,
  children
}) => {
  return /*#__PURE__*/_jsx(Droppable, {
    droppableId: columnData.id,
    type: DND_TYPES.BOARD_CARD,
    children: (provided, snapshot) => /*#__PURE__*/_jsx(ColumnDndContext.Provider, {
      value: {
        isDraggingOver: snapshot.isDraggingOver,
        cardRef: provided.innerRef,
        cardDroppableProps: provided.droppableProps,
        cardPlaceholder: provided.placeholder,
        draggingFromThisWith: snapshot.draggingFromThisWith
      },
      children: children
    })
  });
};
export const useColumnDndContext = () => {
  const dndContext = useContext(ColumnDndContext);
  if (!dndContext) {
    throw new Error('useColumnDndContext must be used within a ColumnDndProvider');
  }
  return dndContext;
};